"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screens = exports.EventTypes = void 0;
var EventTypes = {
  ADJUSTED_FILTER: 'adjusted-filter',
  CLICKED_LINK: 'clicked-link',
  CREATED_ASSET: 'created-asset',
  PAGEVIEW: 'pageview',
  PURCHASED_GOOD: 'purchased-good',
  REDELIVER_GOOD: 'redeliver-good',
  SELECTED_SEARCH_OPTION: 'selected-search-option',
  UNINSTALL_GOOD: 'uninstall-good',
  GOOD_INFO_CLICK: 'good-info-click'
};
exports.EventTypes = EventTypes;
var Screens = {
  DETAILS: 'details',
  DIRECTORY: 'directory',
  MANAGE_PURCHASES: 'manage-purchases'
};
exports.Screens = Screens;